module.exports = __webpack_public_path__ + "img/Pista_30.b50c0fcb.png";